import { quotationsListTypes } from './actionTypes';

const INIT_STATE = {
    quotationsListData: [],
    milestoneConfig: [],
    CountItems: 0,
    isLoading: false,
    error: {},
};

const quotationsList = (state = INIT_STATE, action: any) => {
    switch (action.type) {
        case quotationsListTypes.GET_QUOTATIONS_LIST:
            return {
                ...state,
                isLoading: true,
            };
        case quotationsListTypes.GET_QUOTATIONS_LIST_SUCCESS:
            return {
                ...state,
                quotationsListData: action.payload.QuotationData,
                CountItems: action.payload.CountItems,
                isLoading: false,
            };
        case quotationsListTypes.GET_QUOTATIONS_LIST_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        case quotationsListTypes.GET_MILESTONESCONFIG_QT_SUCCESS:
            return {
                ...state,
                milestoneConfig: action.payload,
            };
        case quotationsListTypes.GET_MILESTONESCONFIG_QT_FAIL:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default quotationsList;
